import {
    Icon,
    IconButton,
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { CommonTable } from '../../_components/table/common.table';
import { PaperTableHeader } from '../../_components/table/header.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { SearchTableHeader } from '../../_components/table/search.table';
import { caseService } from '../../_services/case.service';
import { CaseManageDrawer } from './case-manage';
import { CaseTicketList } from './_components/case-ticketList';
import { accountService } from '../../_services/accounts.service';

export function CasesIndex() {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, order: "desc", pageSize: 50 });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await caseService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 10,
                grow: false,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("Manage/" + row.original.id) }}>
                        {(accountService.isAdmin || accountService.isUser) ? <Icon>edit</Icon> : <Icon>visibility</Icon>}
                    </IconButton>
                ),
            },
            {
                accessorKey: 'id',
                header: 'ID',
            },
            {
                accessorKey: 'client',
                header: 'Client',
            },
            {
                accessorKey: 'clientPOC',
                header: 'Client POC',
            },
            {
                accessorKey: 'clientReference',
                header: 'Client Ref',
            },
            {
                accessorKey: 'noOfTickets',
                header: 'Tickets',
            },
            {
                accessorKey: 'queries',
                header: 'Queries',
            },
        ],
        []
    );

    return (
        <>
            {(accountService.isAdmin || accountService.isUser) &&
                <PaperTableHeader title="Cases" buttons={[
                    { icon: "add", label: "Create Case", onClick: () => { navigate("Create") } },
                ]} />
            }

            {accountService.isClient &&
                <PaperTableHeader title="Cases" buttons={[]} />
            }

            {accountService.isAdmin &&
                <SearchTableHeader inputs={[
                    { label: "Client", name: "client", onChange: setFilter, value: filter.name },
                    { label: "Client Reference", name: "clientReference", onChange: setFilter, value: filter.clientReference },
                ]} />
            }

            <CommonTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
                enableExpanding={false}
                renderDetailPanel={({ row }) => (
                    <CaseTicketList caseId={row.original.id} />
                )}
            />

            <Routes>
                <Route path="Create" element={<CaseManageDrawer onSave={() => { fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="Manage/:id" element={<CaseManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
}
